<template lang="pug">
  DataTablePage(
    pid="parentId"
    cid="id"
    mainColumn="name"
    longColumn="name"
    resource="rbac/menu"
    title="菜单管理"
    label="菜单"
    labelName="name"
    :isTree="true"
    :operation="operation"
    :operationWidth=240
    :tableFullList="tableFullList"
    :tableInitList="tableInitList"
    :filterFullList="filterFullList"
    :filterInitList="filterInitList"
    :orderByInit="orderByInit"
    :createList="createList"
    :updateList="updateList"
    :createFormValues="createFormValues"
    :columns="columns")
</template>

<script>
import DataTablePage from '@/containers/DataTablePage'
import { operationCreate, operationUpdate, operationDelete } from '@/containers/DataTablePage/operation'
import { checkActions, expire } from '@/utils/auth'

export default {
  name: 'SystemMenu',
  components: {
    DataTablePage
  },
  mounted () {
    let result = expire()
    if (!result) {
      this.$router.push('/login')
    }
  },
  data () {
    const hasUpdate = checkActions('/system/menu/update')
    const hasCreate = checkActions('/system/menu/create')
    const hasDelete = checkActions('/system/menu/delete')
    return {
      operation: [{
        ...operationCreate,
        isShow () {
          return hasCreate
        }
      }, {
        ...operationUpdate,
        isShow () {
          return hasUpdate
        }
      }, {
        ...operationDelete,
        isShow () {
          return hasDelete
        }
      }],
      tableInitList: ['name', 'menuTypeName', 'url', 'icon', 'sort', 'enabled', 'remark'],
      tableFullList: ['name', 'menuTypeName', 'url', 'actionIds', 'icon', 'sort', 'enabled', 'remark'],
      filterInitList: ['name', 'enabled', 'menuTypeId'],
      filterFullList: ['name', 'enabled', 'menuTypeId'],
      createList: ['name', 'menuTypeId', 'url', 'icon', 'sort', 'enabled', 'color', 'actionIds', 'remark'],
      updateList: ['name', 'menuTypeId', 'url', 'icon', 'sort', 'enabled', 'color', 'actionIds', 'remark'],
      orderByInit: [{
        name: 'sort',
        sort: 'asc'
      }],
      createFormValues: {
        parentId: '',
        name: '',
        menuTypeId: '',
        url: '',
        icon: '',
        enabled: 1,
        sort: 0,
        remark: ''
      },
      columns: {
        name: {
          label: '菜单名称',
          filter: {
            type: 'input',
            like: true
          },
          form: {
            type: 'input',
            rules: [{
              type: 'required',
              message: '请输入菜单名称'
            }, {
              type: 'maxLength',
              value: 30,
              message: '长度不能大于30'
            }]
          }
        },
        actionIds: {
          label: '接口权限',
          type: 'multiselect',
          relation: 'actions',
          form: {
            type: 'tree'
          }
        },
        menuTypeId: {
          label: '菜单类型',
          relation: 'menuType',
          filter: {
            type: 'select',
            width: 100
          },
          form: {
            type: 'select',
            rules: [{
              type: 'required',
              message: '请输入菜单类型'
            }]
          }
        },
        menuTypeName: {
          label: '菜单类型',
          width: 98,
          filter: {
            type: 'input',
            like: true
          }
        },
        url: {
          label: '菜单路径',
          filter: {
            type: 'input',
            like: true
          },
          form: {
            type: 'input',
            like: true
          }
        },
        icon: {
          label: '菜单图标',
          width: 100,
          form: {
            type: 'input'
          }
        },
        sort: {
          label: '排序',
          width: 70,
          form: {
            type: 'input',
            dataType: 'number'
          }
        },
        color: {
          label: '颜色',
          width: 70,
          form: {
            type: 'input'
          }
        },
        enabled: {
          label: '是否可见',
          width: 98,
          type: 'select',
          relation: 'yesOrNo',
          filter: {
            type: 'select',
            width: 100
          },
          form: {
            type: 'select',
            width: 120,
            rules: [{
              type: 'required',
              dataType: 'boolean',
              message: '请输入是否可见'
            }]
          }
        },
        remark: {
          label: '备注',
          width: 140,
          form: {
            type: 'input',
            isColumn: true,
            large: true,
            rules: [{
              type: 'maxLength',
              value: 120,
              message: '字数不能大于120个字'
            }]
          }
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Menu.vue?1fde8318